import type { FragmentType } from 'src/gql';
import type { Deprecated_HandleItemUpdate } from 'src/types/account';
import { DialogTitle } from '@savvy-kit/components/dialog';
import ItemDialogBackButton from 'src/components/mui/item-dialog-back-button';
import ItemHeader from 'src/components/portfolio/views/item-header';
import TrackedDialog from 'src/components/tracked/tracked-dialog';
import { graphql, unmaskFragment } from 'src/gql';

import LiabilityForm from './liability-form';

export const EditLiabilityDialogFragment = graphql(/* GraphQL */ `
  fragment EditLiabilityDialog on Liability {
    ...LiabilityForm
  }
`);

type EditLiabilityDialogProps = {
  readonly liabilityFrag: FragmentType<typeof EditLiabilityDialogFragment>;
  readonly onClose: () => void;
  readonly onBack: () => void;
  readonly onEdit: Deprecated_HandleItemUpdate;
};

export function EditLiabilityDialog({ liabilityFrag, onClose, onBack, onEdit }: EditLiabilityDialogProps) {
  const liability = unmaskFragment(EditLiabilityDialogFragment, liabilityFrag);

  return (
    <TrackedDialog
      elementName="edit-liability-dialog"
      open
      onOpenChange={(nextOpen) => !nextOpen && onClose()}
      className="flex max-h-[85vh] flex-col p-0"
    >
      <DialogTitle className="sr-only">Edit liability</DialogTitle>
      <ItemDialogBackButton trackedElementName="edit-liability-dialog-back-button" onClick={onBack} />
      {/* pt-20 clears the absolute ItemDialogBackButton above (top-6 + h-10). */}
      <div className="min-h-0 flex-1 overflow-y-auto px-6 pb-6 pt-20">
        <ItemHeader text="Liability details" />
        <LiabilityForm liabilityFrag={liability} onSuccess={onEdit} isEditMode />
      </div>
    </TrackedDialog>
  );
}
